import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

interface TableColumn {
  key: string;    // Clave para la traducción
  field: string;  // Campo a mostrar del objeto de datos
}



@Component({
  selector: 'app-reusable-table',
  templateUrl: './reusable-table.component.html',
  styleUrls: ['./reusable-table.component.scss']
})

export class ReusableTableComponent {
  @Input() columns: TableColumn[] = [];
  @Input() data: any[] = [];
  @Input() editAction!: (item: any) => void;
  @Input() deleteAction!: (item: any) => void;
  @Input() seeProductsAction!: (item: any) => void;
  @Input() actions = ['edit', 'delete'];

  constructor(private translate: TranslateService) { }
  
}
